export const EMPTY_CELL_CONTENT = '---';
